module.exports = __webpack_public_path__ + "img/call_next.7474280c.png";